import { MentoringCreateForm } from 'hb-react/frontoffice/apps/Mentoring/container/Application/Shared/MentoringCreateForm';
import { useCreateMentee } from 'hb-react/frontoffice/apps/Mentoring/hooks/useMutateMentee';
import {
  type CustomAttributeType,
  type Program,
} from 'hb-react/frontoffice/apps/Mentoring/types';
import { LockScreen } from 'hb-react/shared/components/LockScreen';

interface CreateMenteeProps {
  applicationDescription: string;
  attributes: Array<CustomAttributeType>;
  onSuccess: () => void;
  program: Program;
  title: string;
}

export const CreateMentee = ({
  applicationDescription,
  attributes,
  onSuccess,
  program,
  title,
}: CreateMenteeProps) => {
  const { mutateAsync, isPending } = useCreateMentee(program);

  return (
    <>
      {isPending && <LockScreen />}
      <MentoringCreateForm
        attributes={attributes}
        applicationDescription={applicationDescription}
        title={title}
        onSuccess={onSuccess}
        onCreate={mutateAsync}
      />
    </>
  );
};
